import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsSectionContent,
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  proTipsSectionContent,
  serviceTipsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/product-sample-storage-page'

interface ProductSampleStoragePageProps {}

const ProductSampleStoragePage: React.FC<ProductSampleStoragePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
          w-[324px] h-[218px] 
          md-mn:w-[380px] md-mn:h-[286px] 
          lg:!w-[448px] lg:!h-[313px] 
          xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[281px] xl-min:!h-[50px] lg-mn:w-[240px] md-mn:w-[186px] w-[252px] h-[44px]'
        className='xl-min:[&>div:first-child]:!max-w-[745px] lg-mn:[&>div:first-child]:max-w-[436px] md-mn:[&_h1]:w-auto [&_h1]:w-[90%] md-mn:[&_p]:text-pretty [&_p]:text-balance [&_p]:max-w-full'
      />
      <WhyWeSection isBgDark {...whyWeSectionContent} className='md-mn:[&_button]:w-[307px] [&_button]:w-[266px]' />
      <ServiceTipsSectionSection {...serviceTipsSectionContent} />
      <WhyWeSection
        isBgDark
        {...benefitsSectionContent}
        className='[&_article]:bg-transparent [&_article]:border-none'
        imgClassName='w-[130px] h-[130px]'
      />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            xl-min:[&>div>div:last-of-type>div]:!flex-row
            [&>div>div:last-of-type>div]:flex-col
            `}
      />
      <ServiceTipsSectionSection
        isBgDark
        {...proTipsSectionContent}
        className='[&_article]:text-center [&_article_div]:self-center'
        sectionTitleClassName='md-mn:[&_h2]:w-full [&_h2]:w-[90%]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          md-mn:[&_h3]:w-[90%]
          xl-min:[&_button]:!w-[281px]
          lg-mn:[&_button]:w-[236px]
          md-mn:[&_button]:w-[229px]
          [&_button]:w-[280px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} sectionTitleClassName='md-mn:[&_h2]:w-full [&_h2]:w-[90%]' />
    </>
  )
}

export default ProductSampleStoragePage
